export class Item {

    constructor(
        public id: number = null,
        public po_id: number = null,
        public item: string = '',
        public weight: number = null,
        public totalNetWeight: number = 0,
        public damages: string = '',
        public comments: string = '',
        public internallocation_id: number = null,
        public is_pi: number = null,
        public nameInternal: string = '',
        public typeEquipment: string = '',
        public pending: number = 0,
        public enableAsAVirtualContainer: number = 0,
        public nameVirtualContainer: string = '',
        public linkTo: string = null,
        public customType: string = '',
    ) {}
}